export const SET_USER_PREFERENCE = "SET_USER_PREFERENCE";
export const REMOVE_PREFERENCE_DATA = "REMOVE_PREFERENCE_DATA";
